module.exports = __webpack_public_path__ + "img/patent1.33a96565.jpg";